<ng-container *ngIf="loadingSpinnerActive">
  <div
    class="spinner-container"
    @spinnerAnimation
    (@spinnerAnimation.done)="onSpinnerAnimationDone($event)"
  >
    <mat-spinner></mat-spinner>
    <h1 style="margin-left: 2rem">Chargement du modèle...</h1>
  </div>
</ng-container>

<ng-container *ngIf="appContentVisible">
  <mat-drawer-container>
    <mat-drawer mode="over" [opened]="introActive">
      <app-intro-menu
        [infos]="introInfos"
        [modelName]="fileMetadata.modelName"
        [modelVersion]="fileMetadata.modelVersion"
      ></app-intro-menu>
    </mat-drawer>
    <mat-drawer-content>
      <div class="dashboard-container">
        <app-scenario [categories]="scenarioCategories"></app-scenario>
        <app-results
          [categories]="resultCategories"
          [carePathwaySteps]="carePathwaySteps"
          [timeHorizon]="timeHorizon"
          [summaryItems]="summaryItems"
        ></app-results></div
    ></mat-drawer-content>
  </mat-drawer-container>
</ng-container>
